/** The write may have committed; refresh/read the full cart before another write. */
export class CartResultUnconfirmedError extends Error {
  code?: string;

  status?: number;

  constructor(message = 'Unable to confirm the updated cart.') {
    super(/refresh|刷新/i.test(message) ? message : `${message} Refresh your cart before trying again.`);
    this.name = 'CartResultUnconfirmedError';
  }
}
